import { palette } from 'assets/styles/colors';
import theme from '../radius';

const commonStyles = {
  border: `3px solid ${palette.cactus[500]}`,
  margin: '0.75rem',
  borderRadius: theme.radius.sm,
};

const toggleButtonGroup = {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        '.MuiToggleButtonGroup-grouped.Mui-selected': {
          ...commonStyles,
          '&+.MuiToggleButtonGroup-grouped.Mui-selected': {
            ...commonStyles,
          },
        },
      },
      grouped: {
        '&:not(:first-of-type), &:not(:last-of-type)': {
          ...commonStyles,
          border: '3px solid transparent',
        },
      },
    },
  },
};

export default toggleButtonGroup;
